const uk = {
    loginEmail: "Електронна пошта або телефон",
    loginError: "Неправильний e-mail (ім'я користувача) або пароль",
    loginForgotPassword: "Забув пароль",
    loginPassword: "Пароль",
    loginCreateAccount: "Створити акаунт",
    loginLoginIn: "Вхід"
};
export default uk;
